import React from 'react';

export const ExerciseMultipleChoiceAdminContext = React.createContext(null);

export const withExerciseMultipleChoiceAdminContext = (Component) => (props) =>
  (
    <ExerciseMultipleChoiceAdminContext.Provider value={{ isAdmin: true }}>
      <Component {...props} />
    </ExerciseMultipleChoiceAdminContext.Provider>
  );

export const useExerciseMultipleChoiceAdminContext = () =>
  React.useContext(ExerciseMultipleChoiceAdminContext);
